import React, { useContext } from 'react';

import styled from '@emotion/styled';

import LargeCheckMarkIcon from '../Icons/LargeCheckMarkIcon';
import { ModalContext } from './ModalContext';

interface PlainSuccessModalProps {
  successActionFn?: (...args: any[]) => void;
  description: string;
  btnLabel: string;
  className?: string;
  hasCancelBtn?: boolean;
  successLabel?: string | undefined;
}

const PlainSuccessModal: React.FC<PlainSuccessModalProps> = ({
  successActionFn,
  description,
  btnLabel,
  className,
  hasCancelBtn,
  successLabel,
}) => {
  const modalContext = useContext(ModalContext);

  const onClick = (e: any) => {
    modalContext?.setShowModal(false);
    successActionFn && successActionFn();
  };

  return (
    <SuccessViewWrapper>
      <SuccessView>
        <IconArea className={className ? className : ''}>
          <LargeCheckMarkIcon />
        </IconArea>
        <Success>{successLabel ? successLabel : 'Successful'}</Success>
        <SuccessDescription>{description}</SuccessDescription>
      </SuccessView>
      <BtnArea>
        {hasCancelBtn && (
          <CancelBtn onClick={() => modalContext?.setShowModal(false)}>
            Cancel
          </CancelBtn>
        )}
        <SuccessButton onClick={onClick}>{btnLabel}</SuccessButton>
      </BtnArea>
    </SuccessViewWrapper>
  );
};

export default PlainSuccessModal;

const SuccessViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  /* align-items: center; */
`;

const SuccessView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;
  min-height: 289px;
  padding: 40px 18px;
  background-color: ${({ theme }) => theme.palette.pageBgColor};
`;

const Success = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const SuccessButton = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.palette.blueColor};
  padding: 14px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  border-radius: 4px;
  cursor: pointer;
`;

const CancelBtn = styled.button`
  border: none;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 14px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  border-radius: 4px;
  cursor: pointer;
`;

const IconArea = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 16px;
  background: rgba(91, 145, 245, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;

  & > svg {
    color: ${({ theme }) => theme.palette.blueColor};
  }

  &.pink {
    background-color: ${({ theme }) => theme.palette.logiratePrimaryLight};
  }

  &.pink > svg {
    color: ${({ theme }) => theme.palette.logiratePrimary};
  }
`;

const SuccessDescription = styled.div`
  font-size: 14px;
  line-height: 25px;
  font-weight: 400;
  text-align: center;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const BtnArea = styled.div`
  display: flex;
  gap: 16px;
`;
